<template>
  <div class="form-container">
    <h1 class="mb-4">空気環境測定基準値情報編集</h1>
    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
      <div class="mb-3">
        <label for="measureStdNm" class="form-label">空気環境名 <span class="badge text-bg-danger">必須</span></label>
        <select id="measureType" class="form-select" v-model="measure_std.m_measure_type_id" required disabled>
          <option value="" disabled selected>選択してください</option> <!-- placeholder -->
          <option v-for="measureType in measureTypes" :key="measureType.id" :value="measureType.id">{{ measureType.measure_type_nm }}</option>
        </select>
        <div v-if="errorMessages.m_measure_type_id" class="alert alert-danger mt-2">{{ errorMessages.m_measure_type_id[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="minMaxType" class="form-label">最小/最大 <span class="badge text-bg-danger">必須</span></label>
        <select v-model="measure_std.min_max_type" class="form-control" id="minMaxType" required disabled>
          <option value="0">最小</option>
          <option value="1">最大</option>
        </select>
        <div v-if="errorMessages.min_max_type" class="alert alert-danger mt-2">{{ errorMessages.min_max_type[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="stdVal" class="form-label">基準値 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="measure_std.std_val" type="number" placeholder="最小/最大" class="form-control" id="stdVal" required>
        <div v-if="errorMessages.std_val" class="alert alert-danger mt-2">{{ errorMessages.std_val[0] }}</div>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-success mx-1">更新</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { getMeasureTypes, getMeasureStd, updateMeasureStd } from '@/api/axios';

export default {
  setup() {
    const title = ref('空気環境測定基準値情報編集');

    watchEffect(() => {
      document.title = title.value;
    });

    const measureTypes = ref([]);
    const measure_std = ref({
      measure_std_nm: '',
      sort_no: ''
      // 他のフィールド
    });

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const measureStdId = route.params.id; // URLから空気環境測定基準値情報IDを取得

    const loadMeasureStdData = async () => {
      try {
        const response = await getMeasureStd(measureStdId);
        measure_std.value = response.data;
      } catch (error) {
        console.error('空気環境測定基準値情報データの取得に失敗しました:', error);
      }

      try {
        const response = await getMeasureTypes();
        measureTypes.value = response.data;
      } catch (error) {
        console.error('測定種別情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleSubmit = async () => {
      try {
        await updateMeasureStd(measureStdId, measure_std.value);
        store.commit('setFlashMessage', {message: '空気環境測定基準値情報更新完了！', type: 'success'});
        router.push(`/measure-stds/${measureStdId}`);
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        store.commit('setFlashMessage', {message: '空気環境測定基準値情報更新失敗！', type: 'danger'});
        console.error('更新エラー:', error);
      }
    };

    onMounted(loadMeasureStdData);

    return {
      title,
      measureTypes,
      measure_std,
      handleSubmit,
      errorMessages
    };
  }
};
</script>

<style scoped>
.form-container {
  width: 70%;
  padding: 20px;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

input[type="text"],
input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.btn-area{
  text-align: center;
}
</style>
